import { useMediaQuery } from "@mui/material";

const HOVER_CAPABLE_QUERY = "(hover: hover) and (pointer: fine)";

/**
 * True on devices with a persistent pointer (mouse/trackpad), false on
 * touch-only devices. Hybrid touch-laptops report true - that's expected.
 */
export const useHoverCapable = (): boolean => {
  return useMediaQuery(HOVER_CAPABLE_QUERY);
};
